import Tree from 'componentsFor3D/TreeOne';
import HomeOne from 'componentsFor3D/HomeOne';
import HomeTemplate from 'componentsFor3D/HomeTemplate';
import PlantTemplate from 'componentsFor3D/PlantTemplate';
import MushroomTemplate from 'componentsFor3D/MushroomTemplate';
import { Detailed } from '@react-three/drei';
import GiantMushroom from 'componentsFor3D/GiantMushroom';
import ModelLoader from 'templateFor3D/ModelLoader';
import Portal from 'componentsFor3D/Portal';
import SnowTreeInstance from 'individualModels/SnowTreeInstance';
import Palace from 'individualModels/Palace';
import TreeInstance from 'individualModels/TreeInstance';
import HtmlNumerTag from 'componentsFor3D/HtmlNumerTag';

export default function Area1ForPart1() {
  return (
    <group>
      <Detailed distances={[0, 2, 12]}>
        <group>
          <ModelLoader
            url='special/castle.glb'
            scale={0.002}
            rot={[0, -Math.PI / 2, 0]}
            pos={[0.6, 0.045, 0.1]}
          />
          <ModelLoader
            url='special/windhouse.glb'
            scale={0.008}
            rot={[0, -Math.PI * 0.3, 0]}
            pos={[-0.15, 0.05, 0.71]}
          />
          <ModelLoader
            url='special/evilcamp.glb'
            scale={0.02}
            rot={[0, -Math.PI * 0.01, 0]}
            pos={[-0.35, 0.05, 0.34]}
          />
          <ModelLoader
            url='special/tower.glb'
            scale={0.002}
            rot={[0, -Math.PI * 0, 0]}
            pos={[-0.2, 0.05, 0.46]}
          />
          <ModelLoader
            url='special/tower.glb'
            scale={0.002}
            rot={[0, -Math.PI * 1, 0]}
            pos={[-0.2, 0.05, 0.57]}
          />
          <ModelLoader
            url='special/mushroomHome.glb'
            scale={0.001}
            rot={[0, -Math.PI * 0.2, 0]}
            pos={[-0.7, 0.05, 0.17]}
          />
          <Portal />
          <group position={[-0.033, 0.01, -0.07]}>
            <HomeTemplate
              pos={[0.78, 0.046, 0.35]}
              rot={[0, -Math.PI / 2, 0]}
            />
            <HomeTemplate
              pos={[0.76, 0.046, 0.33]}
              rot={[0, -Math.PI / 2, 0]}
              type={1}
            />
            <HomeTemplate
              pos={[0.78, 0.046, 0.34]}
              rot={[0, -Math.PI / 3, 0]}
              type={2}
            />
            <HomeTemplate
              pos={[0.75, 0.046, 0.32]}
              rot={[0, -Math.PI / 3, 0]}
              type={3}
            />
            <HomeTemplate
              pos={[0.74, 0.046, 0.32]}
              rot={[0, -Math.PI / 2, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.74, 0.046, 0.336]}
              rot={[0, -Math.PI / 2, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.74, 0.046, 0.366]}
              rot={[0, -Math.PI / 3, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.75, 0.046, 0.373]}
              rot={[0, -Math.PI, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.764, 0.046, 0.373]}
              rot={[0, -Math.PI, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.778, 0.046, 0.37]}
              rot={[0, Math.PI / 6, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.787, 0.045, 0.357]}
              rot={[0, Math.PI / 2.5, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.791, 0.045, 0.342]}
              rot={[0, Math.PI / 2.3, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.792, 0.045, 0.328]}
              rot={[0, Math.PI / 2, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.785, 0.045, 0.316]}
              rot={[0, Math.PI / 1.2, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.77, 0.045, 0.312]}
              rot={[0, Math.PI, 0]}
              type={5}
            />
            <HomeTemplate
              pos={[0.754, 0.045, 0.312]}
              rot={[0, Math.PI, 0]}
              type={5}
            />
            <PlantTemplate pos={[0.77, 0.046, 0.32]} />
            <PlantTemplate pos={[0.78, 0.046, 0.32]} type={2} />
            <PlantTemplate pos={[0.79, 0.046, 0.33]} type={3} />
            <PlantTemplate pos={[0.77, 0.046, 0.37]} type={5} />
            <PlantTemplate pos={[0.743, 0.046, 0.34]} type={5} />
            <PlantTemplate pos={[0.748, 0.046, 0.37]} type={6} />
            <PlantTemplate pos={[0.748, 0.046, 0.36]} type={8} />
            <PlantTemplate pos={[0.75, 0.046, 0.34]} type={9} />
            <PlantTemplate pos={[0.769, 0.046, 0.36]} type={13} />
            <HomeOne pos={[0.76, 0.046, 0.362]} rot={[0, -Math.PI, 0]} />
            <HomeOne pos={[0.775, 0.046, 0.36]} rot={[0, -Math.PI / 2, 0]} />
            <HomeOne pos={[0.768, 0.046, 0.342]} rot={[0, Math.PI / 3, 0]} />
          </group>
          <group position={[-0.1, 0, 0]}>
            <MushroomTemplate pos={[0.65, 0.05, 0.29]} />
            <MushroomTemplate pos={[0.66, 0.049, 0.296]} type={2} />
            <MushroomTemplate pos={[0.68, 0.049, 0.296]} type={10} />
            <MushroomTemplate pos={[0.68, 0.049, 0.292]} type={5} />
            <MushroomTemplate pos={[0.672, 0.049, 0.3]} type={20} />
            <MushroomTemplate pos={[0.672, 0.049, 0.28]} type={11} />
            <PlantTemplate pos={[0.672, 0.047, 0.29]} type={10} />
            <PlantTemplate
              pos={[0.657, 0.047, 0.29]}
              rot={[0, Math.PI, 0]}
              type={12}
            />
            <PlantTemplate
              pos={[0.68, 0.047, 0.28]}
              rot={[0, Math.PI, 0]}
              type={12}
            />
            <PlantTemplate
              pos={[0.66, 0.047, 0.29]}
              rot={[0, Math.PI, 0]}
              type={9}
            />
          </group>
          <Palace
            pos={[0.407, 0.11, 0.214]}
            scale={0.002}
            rot={[0, Math.PI * 1.8, 0]}
          />
          <ModelLoader
            pos={[0.424, 0.104, 0.222]}
            scale={0.0001}
            rot={[Math.PI * 0.2, Math.PI * 1.45, 0]}
            url='special/crystal.glb'
          />
          <GiantMushroom />
          <HtmlNumerTag name='I' pos={[0.65, 0.05, 0.28]} />
          <HtmlNumerTag name='II' pos={[0.4, 0.1, 0.2]} />
          <SnowTreeInstance />
          <TreeInstance />
        </group>
        <group></group>
      </Detailed>
    </group>
  );
}
